module.exports = __webpack_public_path__ + "static/img/burnaby3.f65a673.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/burnaby3.jpg
// module id = 77
// module chunks = 9